<template>
  <el-dialog
    :title="setTitle"
    :visible="show"
    width="70%"
    @close="closeWindow"
    class="dialog_container"
  >
    <div class="add-title">
      <div>
        <div
          v-for="(item, index) in showList"
          :key="index"
          class="list-1"
          :class="{ change: tapId == item.id }"
          @click="chioceId(item.id)"
        >
          <div>{{ item.name }}</div>
        </div>
      </div>
      <div>
        <div v-show="tapId == 1">
          <CustomerInfo
            @customerData="customerData"
            :formData="formData"
            @oldData="oldData"
            :setTitle="setTitle"
          ></CustomerInfo>
        </div>
        <div v-show="tapId == 2">
          <GovInfo
            @governmentAssistance="governmentAssistance"
            :formData="formData"
            :serviceStation="setTitle=='新增'?wcustomerData.serviceStation:formData.serviceStation"
            :setTitle="setTitle"
          ></GovInfo>
        </div>
        <InfoServices v-show="tapId == 12" :formData="formData" :customerId="formData.id"></InfoServices>
        <div v-show="tapId == 3">
          <HealthInfo
            @healthInfo="healthInfo"
            :formData="formData"
            :setTitle="setTitle"
            :wHealthData="wHealth"
          ></HealthInfo>
        </div>
        <!-- <div v-show="tapId == 4">
          <AddOrder></AddOrder>
        </div> -->
        <div v-show="tapId == 5">
          <Liaison :formData="formData" :customerId="formData.id"></Liaison>
        </div>
        <div v-show="tapId == 6">
          <ServerRecord :formData="formData"></ServerRecord>
        </div>
        <!-- <div v-show="tapId == 7">
                    <Location :formData="formData"></Location>
                </div>
                <div v-show="tapId == 8">
                    <Trajectory></Trajectory>
                </div> -->
        <div v-show="tapId == 9">
          <Enclosure
            v-if="tapId == 9"
            @getGjInfo="getGjInfo"
            :formData="formData"
            :setTitle="setTitle"
          ></Enclosure>
        </div>
        <div v-show="tapId == 10">
          <WarningInfo v-if="tapId == 10" :formDatas="formData"></WarningInfo>
        </div>
        <div v-show="tapId == 11">
          <servicePlan></servicePlan>
        </div>
      </div>
    </div>
    <div class="btn">
      <div>
        <el-button :disabled="setTitle == '查看'" type="primary" @click="send"
          >保存</el-button
        >
        <el-button @click="closeWindow">取 消</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import CustomerInfo from "./customerInfo.vue"
import GovInfo from "./govInfo.vue"
import HealthInfo from "./healthInfo.vue"
// import AddOrder from "./addOrder.vue";
import Liaison from "./liaison.vue"
import ServerRecord from "./serverRecord.vue"
import Location from "./location.vue"
import Trajectory from "./trajectory.vue"
import Enclosure from "./enclosure.vue"
import WarningInfo from "./warningInfo.vue"
import servicePlan from "./servicePlan.vue"
import exportVue from "@/utils/exportVue"
import InfoServices from "./infoServices.vue"
export default {
  components: {
    CustomerInfo,
    GovInfo,
    HealthInfo,
    // AddOrder,
    Liaison,
    ServerRecord,
    Location,
    Trajectory,
    Enclosure,
    WarningInfo,
    servicePlan,
    InfoServices
  },
  name: "AddInfo",
  props: {
    showStatus: {
      type: Boolean,
      default: false,
    },
    setTitle: {
      type: String,
      default: "",
    },
    formData: {},
  },
  data() {
    return {
      tapId: "1",
      showList: [
        {
          id: "1",
          name: "客户资料",
        },
        {
          id: "2",
          name: "政府援助信息",
        },
         {
          id: "12",
          name: "信息服务",
        },
        {
          id: "3",
          name: "健康档案",
        },
        // {
        //   id: '4',
        //   name: '新增工单'
        // },
        {
          id: "5",
          name: "联络历史",
        },
        {
          id: "6",
          name: "服务记录",
        },
        // {
        //     id: "7",
        //     name: "定位信息",
        // },
        // {
        //     id: "8",
        //     name: "轨迹信息",
        // },
        {
          id: "9",
          name: "轨迹信息",
        },
        {
          id: "10",
          name: "预警信息",
        },
        {
          id: "11",
          name: "服务计划",
        },
      ],
      wcustomerData: {},
      wGovernmentAssistance: {},
      wHealth: {},
      gjInfo: {},
      oldData: {},
      cusid: "",
    }
  },
  computed: {
    show() {
      return this.showStatus
    },
  },
  created() {
    this.$emit("oldData", this.oldData)
    exportVue.$on("health", (data) => {
      if (data) {
        this.cusid = data
      }
    })
  },
  watch:{
    formData: {
      handler(val) {
        this.formData =val
        console.log(val,'addinfo')
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    chioceId(id) {
      this.tapId = id

      if (id == 3) {
        exportVue.$emit("wcustomerData", this.wcustomerData)
        let dd = ""
        if (this.setTitle == "新增") {
          dd = this.cusid
        } else {
          dd = this.formData.yptCustomerId
        }
        if (dd) {
          this.$http
            .request({
              url: "/ypt/admin/all/customer/info/findHealth",
              method: "POST",
              data: {
                id: dd,
              },
            })
            .then((res) => {
              if (res.code === 200) {
                if (res.content != null) {
                  exportVue.$emit("oldhealth", res.content)
                }
              }
            })
        }
      }
    },
    send() {
      // debugger

      this.$set(this.wcustomerData, "zfAssistance", this.wGovernmentAssistance)
      this.$set(this.wcustomerData, "customerHealth", this.wHealth)
      // if (this.setTitle == "编辑") {
      //     this.wcustomerData.yptCustomerId = this.wcustomerData.yptId
      // }
      if (!this.wcustomerData.customerName) {
        this.$message.error("姓名不能为空,请输入姓名")
        return
      }
      // if (!this.wcustomerData.idCard) {
      //   this.$message.error("身份证不能为空,请输入身份证号")
      //   return
      // }

      if (!this.wcustomerData.dataId) {
        this.$message.error("区域名称不能为空,请输入区域名称")
        return
      }
      if (!this.wcustomerData.lifeArea) {
        this.$message.error("生活区域不能为空,请输入生活区域")
        return
      }
      if (!this.wcustomerData.serviceStation) {
        this.$message.error("所属机构不能为空,请选择所属机构")
        return
      }
      if (this.wcustomerData.customerType != null) {
        this.wcustomerData.customerType =
          this.wcustomerData.customerType.toString()
      }
      if (!this.wcustomerData.address) {
        this.$message.error("联系地址不能为空")
        return
      }

      if (this.gjInfo.pointPosition) {
        this.wcustomerData.pointPosition = this.gjInfo.pointPosition
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      let url = ""
      if (this.setTitle == "新增") {
        this.wcustomerData.id = ""
        url = "/jjyl/admin/center/customer/info/insert"
      } else if (this.setTitle == "编辑") {
        this.wcustomerData.phone = ""
        this.wcustomerData.idCard = ""
        url = "/jjyl/admin/center/customer/info/update"
      }

      let parmar = this.wcustomerData
      parmar.zfAssistance.projectType = parmar.zfAssistance.projectType
        ? parmar.zfAssistance.projectType.toString()
        : ""
      this.wcustomerData.serviceRemark = parmar.zfAssistance.serviceRemark
      this.$http
        .request({
          url: url,
          method: "POST",
          data: this.wcustomerData,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(`操作成功`)
            this.wcustomerData = {}
            this.$emit("updateShowStatus", true)
            // this.show = false
            loading.close()
          } else {
            //this.$message.error("res.message")
            loading.close()
          }
        })
        .catch((error) => {
          this.$emit("updateShowStatus", true)
          loading.close()
        })
    },

    closeWindow() {
      // this.show = false
      this.$emit("updateShowStatus", false)
      this.formData = {}
      this.$delete(this.formData, "hide")
      this.$set(this.formData, "hide", true)
    },
    // 获取政府援助数据
    governmentAssistance(data) {
      this.wGovernmentAssistance = data
    },
    customerData(data) {
      this.wcustomerData = data
    },
    healthInfo(data) {
      this.wHealth = data
    },
    getGjInfo(data) {
      this.gjInfo = data
    },
  },
}
</script>
<style lang="less" scoped>
.dialog_container {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e5e5e5;
  }
}

.btn {
  width: 100%;
  display: flex;
  margin-top: 30px;
  justify-content: center;
}

.add-title {
  width: 100%;
  display: flex;
}

.add-title > div:first-child {
  width: 120px;
  background-color: #a2aaaa;
}

.add-title > div:nth-child(2) {
  flex: 1;
}

.list-1 {
  width: 100%;
  margin: 0 auto;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-bottom: 20px;
  cursor: pointer;
}

.change {
  width: calc(100% - 2px);
  color: #0000ff;
  background-color: #e0f0fa;
  border-left: 2px solid #0000ff;
}
</style>
